import validation from '../../../../../../../modules/Gull/Framework/validation.js';

/**
 * View object handling UBO declaration functionality
 * @namespace
 */
const view = {
	elementAantalBelanghebbendeSelect: null,
	elementPersonenContainer: null,

	/**
	 * Init
	 *
	 * @returns {void}
	 */
	init() {
		view.initElements();
		view.initEvents();
	},

	/**
	 * Initialize elements
	 *
	 * @returns {void}
	 */
	initElements: () => {
		view.elementAantalBelanghebbendeSelect = document.querySelector('[name="aantalBelanghebbende"]') ?? null;
		view.elementPersonenContainer = document.querySelectorAll('[data-natuurlijke-persoon]') ?? null;
		view.elementBelanghebbendePersonenContainer = document.querySelector('[data-belanghebbende-personen]') ?? null;
	},

	/**
	 * Initialize events
	 *
	 * @returns {void}
	 */
	initEvents: () => {
		view.elementAantalBelanghebbendeSelect?.addEventListener('change', view.handleAantalBelanghebbendeChange);
	},

	/**
	 * Handle aantal belanghebbende change
	 *
	 * @returns {void}
	 */
	handleAantalBelanghebbendeChange: () => {
		const aantalBelanghebbendeValue = view.elementAantalBelanghebbendeSelect.value ?? 0;

		view.elementPersonenContainer.forEach((element) => {
			element.classList.add('d-none');
			element.querySelectorAll('input, select').forEach((input) => {
				validation.removeRequired(input);
				input.setAttribute('name-org', input.name);
				input.setAttribute('name', '');
			});
		});

		for (let i = 1; i <= aantalBelanghebbendeValue; i++) {
			const element = document.querySelector(`[data-natuurlijke-persoon="${i}"]`);
			const elementInputs = element.querySelectorAll('input, select');
			element.classList.remove('d-none');
			elementInputs.forEach((input) => {
				if (!input.name.includes('toevoeging') && !input.name.includes('tussenvoegsel')) {
					validation.addRequired(input);
					const nameOrg = input.getAttribute('name-org');
					input.setAttribute('name', nameOrg);
				}
			});
		}
	},
};

export default view;
